export default __webpack_public_path__ + "static/media/home.d489a6a6.svg";